import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import iconImage from '../images/ic_nobg.png';
import UserService from "../services/user.service";

const Home = () => {
  const currentMainThemeColor = localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor = localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";

  const styles = {
    pageTitle: {
      padding: '2rem 1rem',
      marginBottom: '2rem',
      backgroundColor: currentSecondaryThemeColor, 
      borderRadius: '0.3rem',
      height: 380,
      display: 'flex',
      justifyContent: 'center',
    },
  }

  const [content, setContent] = useState("");
  const { user: currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    UserService.getPublicContent(currentUser.token).then(
      (response) => {
        setContent(response.data.data);
      },
      (error) => {
        const _content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
    <div className="container">
      <header style={styles.pageTitle}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img src={iconImage} alt="iconImage" style={{width: 350, height: 300}} />
          <h1>{'Landlord Automations'}</h1>
        </div>
      </header>
      <div>
        <h3>{content}</h3>
      </div>
    </div>
  );
};

export default Home;
